// const inputArray = [
//     {
//         name: 'a',
//         originalData: [
//             {
//                 x: 0,
//                 y: 1
//             },
//             {
//                 x: 5,
//                 y: 6
//             },
//             {
//                 x: 2,
//                 y: 8
//             },
//         ]
//     },
//     {
//         name: 'b',
//         originalData: [
//             {
//                 x: 77,
//                 y: 55
//             },
//             {
//                 x: 88,
//                 y: 99
//             },
//             {
//                 x: 94,
//                 y: 23
//             },
//         ]
//     },
// ]

// [
//     {
//         name: 'a',
//         originalData: [
//             {
//                 x: 0,
//                 y: 1
//             },
//             {
//                 x: 5,
//                 y: 6
//             },
//             {
//                 x: 2,
//                 y: 8
//             },
//         ],
//         originalXValues : [0, 5, 2],
//         originalYValues : [1, 6, 8]
//     },
//     {
//         name: 'b',
//         originalData: [
//             {
//                 x: 77,
//                 y: 55
//             },
//             {
//                 x: 88,
//                 y: 99
//             },
//             {
//                 x: 94,
//                 y: 23
//             },
//         ],
//         originalXValues : [77, 88, 94],
//         originalYValues : [55, 99, 23]
//     }
// ]

export const xyExtraction = (inputArray) => {
    return inputArray.map(item => {
        const originalXValues = item.originalData.map(data => data.x);
        const originalYValues = item.originalData.map(data => data.y);
        return {
            name: item.name,
            originalData: item.originalData,
            originalXValues: originalXValues,
            originalYValues: originalYValues
        };
    });
}

